/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  static #STORAGE_KEY_HANDLES = 'viewedProductHandles';
  // These Bono products are unlisted direct-link QA trials.
  static #TRIAL_PRODUCTS = new Map([
    ['qa-bono-stock', '9348653252746'],
    ['qa-bono-fixed-custom-size', '9347108208778'],
  ]);
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 20;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId, productHandle = '') {
    this.#removeTrialProducts();
    if (this.#TRIAL_PRODUCTS.has(productHandle) || [...this.#TRIAL_PRODUCTS.values()].includes(String(productId))) return;

    if (productId) {
      let viewedProducts = this.getProducts();

      viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
      viewedProducts.unshift(productId);
      viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

      localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
    }

    if (!productHandle) return;

    let viewedProductHandles = this.getProductHandles();
    viewedProductHandles = viewedProductHandles.filter((handle) => handle !== productHandle);
    viewedProductHandles.unshift(productHandle);
    viewedProductHandles = viewedProductHandles.slice(0, this.#MAX_PRODUCTS);

    localStorage.setItem(this.#STORAGE_KEY_HANDLES, JSON.stringify(viewedProductHandles));
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
    localStorage.removeItem(this.#STORAGE_KEY_HANDLES);
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    this.#removeTrialProducts();
    return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
  }

  static getProductHandles() {
    this.#removeTrialProducts();
    return JSON.parse(localStorage.getItem(this.#STORAGE_KEY_HANDLES) || '[]');
  }

  static #removeTrialProducts() {
    const trialIds = new Set(this.#TRIAL_PRODUCTS.values());
    const readList = (key) => {
      try {
        const value = JSON.parse(localStorage.getItem(key) || '[]');
        return Array.isArray(value) ? value : [];
      } catch {
        return [];
      }
    };
    const productIds = readList(this.#STORAGE_KEY);
    const handles = readList(this.#STORAGE_KEY_HANDLES);
    const filteredIds = productIds.filter((id) => !trialIds.has(String(id)));
    const filteredHandles = handles.filter((handle) => !this.#TRIAL_PRODUCTS.has(handle));
    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(filteredIds));
    localStorage.setItem(this.#STORAGE_KEY_HANDLES, JSON.stringify(filteredHandles));
  }
}
